import * as Styled from './StyleButtonBadge'

const AnsweredBadge = () => {
  return <Styled.AnsweredButton>답변 완료</Styled.AnsweredButton>
}

export default AnsweredBadge
